import React from "react";
import TransactionModal from "../TransactionProcessing/TransactionModal";
import CloseIcon from "../../../assets/svgs/closeIcon.svg";
// import CloseIcon from "@material-ui/icons/Close";
import { Button, CircularProgress } from "@material-ui/core";
import useStyles from "./switchModalStyles";
import BigNumber from "bignumber.js";
import millify from "millify";
import { switchNetwork } from "../../../utils/web3Connectors";
import { supportedChains } from "../../../contract/constant";

function SwitchNetworkModal({
  isChainCorrect,
  setIsChainCorrect,
  chainId,
  value,
  claimTokensModal,
}) {
const classes = useStyles();
  return (
    <div>
      <TransactionModal
      height={"max-content"}
        open={isChainCorrect}
        claimTokensModal={claimTokensModal}
      >
        <div>
          {/* <div>
            <img
              src={CloseIcon}
              style={{
                display: "flex",
                marginLeft: "auto",
                fontWeight: "500",
                // transform: "scale(1.4)",
                cursor: "pointer",
                marginTop: "10px",
              }}
              onClick={() => {
                setIsChainCorrect(false);
              }}
            />
          </div> */}
          <div style={{ color: "#282828", textAlign: "center" }}>
            <div
              style={{
                fontStyle: "normal",
                fontWeight: "800",
                fontSize: "20px",
                lineHeight: "25px",
                color: "#282828",
              }}
            >
              Switch your network to {chainId == supportedChains[0]?"ethereum":"binance"}
            </div>
            <div
              style={{
                paddingTop: "20px",
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "16px",
                lineHeight: "140%",
                /* or 22px */

                textAlign: "center",

                color: "#696969",
              }}
            >
              Your wallet will ask permission to switch network. Please grant it
              to proceed.
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "20px",
              }}
            >
              <div style={{}}>
                <Button
                  style={{
            
                  }}
                  className={classes.cancelButton}
                  onClick={() => {
                    setIsChainCorrect(false);
                  }}
                >
                  CANCEL
                </Button>
              </div>
              <div>
                <Button
                  style={{
                  
                  }}
                  className={classes.switchButton}
                  onClick={() => {
                    switchNetwork(chainId);
                    setIsChainCorrect(false);
                  }}
                >
                  SWITCH
                </Button>
              </div>
            </div>
          </div>
        </div>
      </TransactionModal>
    </div>
  );
}

export default SwitchNetworkModal;
